<template>
  <rhcn-drawer @on-close="onClose">
    <div class="drawer-form exchange-form" style="width: 637px;">
      <div>
        <rhcn-step :steps="steps" :active="2"></rhcn-step>
      </div>
      <div v-loading="loading" class="transfer-review-wrapper">
        <div class="content">
          <el-descriptions :title="$t('message.transfer.payeeInformation')" :column="1" :colon="false"
            labelClassName="transfer-review-label" contentClassName="transfer-review-content">
            <template v-if="`${app.userLogin.businessType}` !== '0'">
              <el-descriptions-item :label="$t('message.contact.accountName')">{{ contactInfo &&
                contactInfo.bankAccount }}</el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.accountCurrency')">{{ contactInfo &&
                contactInfo.payoutCurrency }}</el-descriptions-item>
              <el-descriptions-item v-if="contactInfo && contactInfo.paymentMethod"
                :label="$t('message.contact.paymentMethod')">
                {{ contactInfo && getEnantiomericValue(PAYMENT_METHOD_OPTIONS, contactInfo.paymentMethod) }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('message.payee.cardNumber')"
                v-if="contactInfo && contactInfo.cardNumber">{{ contactInfo &&
                  contactInfo.cardNumber }}</el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.bankCountryRegion')">{{ contactInfo &&
                contactInfo.bankCountry }}</el-descriptions-item>
              <el-descriptions-item :label="$t('message.payee.bankName')" v-if="contactInfo && contactInfo.bankName">{{
                contactInfo &&
                contactInfo.bankName }}</el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.swiftCode')"
                v-if="contactInfo && contactInfo.swiftCode">{{ contactInfo &&
                  contactInfo.swiftCode }}</el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.sortCode')"
                v-if="contactInfo && contactInfo.sortCode">{{ contactInfo &&
                  contactInfo.sortCode }}</el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.beneficiaryName')"
                v-if="contactInfo && contactInfo.payee">{{ contactInfo && contactInfo.payee }}</el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.beneficiaryCategory')">
                {{ contactInfo && $t(getEnantiomericValue(ACCOUNT_BELONG_OPTIONS, contactInfo.accountBelong)) }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.beneficiaryType')">
                {{ contactInfo && $t(getEnantiomericValue(ENTITY_TYPE_OPTIONS, contactInfo.entityType)) }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.certificateNo')"
                v-if="contactInfo && contactInfo.idNumber">
                {{ contactInfo && contactInfo.idNumber }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.mobilePhone')" v-if="contactInfo && contactInfo.phone">
                {{ contactInfo && contactInfo.phone }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.beneficiaryCountry')"
                v-if="contactInfo && contactInfo.payeeCountry">
                {{ contactInfo && contactInfo.payeeCountry }}
              </el-descriptions-item>
              <el-descriptions-item v-if="contactInfo && contactInfo.payeeAddress"
                :label="$t('message.contact.beneficiaryAddress')">
                {{ contactInfo && contactInfo.payeeAddress }}
              </el-descriptions-item>
              <el-descriptions-item v-if="info.fileId" :label="$t('message.transfer.payDoc')"
                :label-style="{ 'line-height': '24px' }">
                <el-button size="small" type="default"
                  style="padding-top:5px;padding-bottom: 5px;background-color: #FFF;"
                  @click="downloadFile(info.fileId[0].url)">
                  <span style="color:#264373;">{{ info && info.fileId[0].name }}</span>
                  <span style="margin-left:45px;font-size: 12px;margin-top: 1px;" class="iconfont icon-Download"></span>
                </el-button>
              </el-descriptions-item>
              <template v-if="info.materialList && info.materialList.length">
                <template v-for="(materialItem, index) in info.materialList">
                  <template v-if="materialItem.fileUrl && materialItem.materialFormat !== '2'">
                    <el-descriptions-item :label="materialItem.materialName" :label-style="{ 'line-height': '24px' }"
                      :key="index">
                      <el-button size="small" type="default"
                        style="padding-top:5px;padding-bottom: 5px;background-color: #FFF;"
                        @click="downloadFile(materialItem.fileUrl)">
                        <span style="color:#264373;">{{
                          materialItem.fileUrl.split('/')[materialItem.fileUrl.split('/').length
                          - 1] }}</span>
                        <span style="margin-left:45px;font-size: 12px;margin-top: 1px;"
                          class="iconfont icon-Download"></span>
                      </el-button>
                    </el-descriptions-item>
                  </template>
                  <template v-else>
                    <el-descriptions-item :label="materialItem.materialName" :key="index">
                      {{ materialItem.fileUrl }}
                    </el-descriptions-item>
                  </template>
                </template>
              </template>
            </template>
            <template v-if="`${app.userLogin.businessType}` === '0' && contactInfo">
              <el-descriptions-item :label="$t('message.contact.transferTo')">{{ contactInfo.bankCountry
              }}</el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.beneficiaryType')">
                {{ $t(getEnantiomericValue(ENTITY_TYPE_OPTIONS, contactInfo.entityType)) }}
              </el-descriptions-item>
              <el-descriptions-item v-if="contactInfo.entityType === '0'" :label="$t('message.contact.companyName')">
                {{ contactInfo.companyName }}
              </el-descriptions-item>
              <el-descriptions-item v-if="contactInfo.entityType === '1'" :label="$t('message.contact.firstName')">
                {{ contactInfo.firstName }}
              </el-descriptions-item>
              <el-descriptions-item v-if="contactInfo.entityType === '1'" :label="$t('message.contact.lastName')">
                {{ contactInfo.lastName }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.birthDate')"
                v-if="contactInfo.entityType === '1' && contactInfo.birthDate && ['ID', 'VN'].includes(contactInfo.bankCountry)">
                {{ contactInfo.birthDate }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.beneficiaryCountry')" v-if="contactInfo.payeeCountry">
                {{ contactInfo.payeeCountry }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.state')"
                v-if="contactInfo.state && ['CA', 'US'].includes(contactInfo.bankCountry)">
                {{ contactInfo.state }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.city')"
                v-if="contactInfo.city && ['ID', 'TH', 'US', 'CA', 'JP', 'KR'].includes(contactInfo.bankCountry)">
                {{ contactInfo.city }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.mobilePhone')"
                v-if="contactInfo.phone && ['BR', 'PH', 'TH', 'VN', 'MY', 'MX', 'GB', 'KR'].includes(contactInfo.bankCountry)">
                {{ contactInfo.phone }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.address')"
                v-if="contactInfo.address1 && ['ID', 'TH', 'CA', 'EG', 'SA', 'US', 'JP', 'KR', 'VN'].includes(contactInfo.bankCountry)">
                {{ `${contactInfo.address1} ${contactInfo.address2 || ''} ${contactInfo.address3 || ''}` }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('message.contact.zipCode')"
                v-if="contactInfo.zipCode && ['CA', 'US', 'GB'].includes(contactInfo.bankCountry)">
                {{ contactInfo.zipCode }}
              </el-descriptions-item>
              <el-descriptions-item :label="getVatNumberText(contactInfo)"
                v-if="contactInfo.vatNumber && ['BR'].includes(contactInfo.bankCountry)">
                {{ contactInfo.vatNumber }}
              </el-descriptions-item>
              <template v-if="info.payoutMethod === 'BANK_TRANSFER' || info.payoutMethod === 'SWIFT'">
                <el-descriptions-item v-if="contactInfo.bankName" :label="$t('message.contact.bankName')">
                  {{ contactInfo.bankName }}
                </el-descriptions-item>
                <el-descriptions-item v-if="contactInfo.swiftCode" :label="$t('message.contact.swiftCode')">
                  {{ contactInfo.swiftCode }}
                </el-descriptions-item>
                <el-descriptions-item v-if="contactInfo.payee" :label="$t('message.contact.nickname')">
                  {{ contactInfo.payee }}
                </el-descriptions-item>
                <el-descriptions-item v-if="contactInfo.accountType" :label="$t('message.contact.acType')">
                  {{ getEnantiomericValue(ACCOUNT_TYPE_OPTIONS, contactInfo.accountType) }}
                </el-descriptions-item>
                <el-descriptions-item v-if="contactInfo.cardNumber" :label="$t('message.contact.accountNumber')">
                  {{ contactInfo.cardNumber }}
                </el-descriptions-item>
                <el-descriptions-item v-if="contactInfo.payoutCurrency" :label="$t('message.contact.accountCurrency')">
                  {{ contactInfo.payoutCurrency }}
                </el-descriptions-item>
                <el-descriptions-item
                  v-if="contactInfo.sortCode && ['ID', 'PH', 'US', 'CA', 'BR', 'KR', 'GB', 'JP'].includes(contactInfo.bankCountry)"
                  :label="$t('message.contact.bankCode')">
                  {{ contactInfo.sortCode }}
                </el-descriptions-item>
                <el-descriptions-item
                  v-if="contactInfo.branchCode && ['BR', 'CA', 'ID', 'JP', 'VN'].includes(contactInfo.bankCountry)"
                  :label="$t('message.contact.branchCode')">
                  {{ contactInfo.branchCode }}
                </el-descriptions-item>
              </template>
              <template v-if="info.payoutMethod === 'E_WALLET'">
                <el-descriptions-item v-if="contactInfo.walletType" :label="$t('message.contact.walletType')">
                  {{ getWalletTypeText(contactInfo.walletType) }}
                </el-descriptions-item>
                <el-descriptions-item v-if="contactInfo.walletPhone" :label="$t('message.contact.walletPhone')">
                  {{ getWalletPhoneText(contactInfo.walletPhone) }}
                </el-descriptions-item>
              </template>
              <template v-if="info.payoutMethod === 'CASH_PICKUP'">
                <el-descriptions-item v-if="contactInfo.pickUpBankName" :label="$t('message.contact.pickUpBank')">
                  {{ contactInfo.pickUpBankName }}
                </el-descriptions-item>
                <el-descriptions-item v-if="contactInfo.pickUpBankName" :label="$t('message.contact.branchName')">
                  {{ contactInfo.pickUpBankBranchName }}
                </el-descriptions-item>
                <el-descriptions-item v-if="contactInfo.pickUpBankAddress"
                  :label="$t('message.contact.bankBranchAddress')">
                  {{ contactInfo.pickUpBankAddress }}
                </el-descriptions-item>
              </template>
            </template>
          </el-descriptions>
        </div>
        <div class="content margin-top-20">
          <!-- <el-descriptions :title="$t('message.transfer.payeeInformation')"
            :column="1"
            :colon="false"
            labelClassName="transfer-review-label"
            contentClassName="transfer-review-content">
            <el-descriptions-item :label="$t('message.transfer.contact')">{{contactInfo && contactInfo.payeeAddress}}</el-descriptions-item>
            <el-descriptions-item :label="$t('message.transfer.cardHolder')">{{contactInfo && contactInfo.cardInfo.holderName}}</el-descriptions-item>
          </el-descriptions>
          <div style="border-bottom: 1px solid #D7E1F2;"></div> -->
          <el-descriptions :title="$t('message.transfer.payoutInfo')" :column="1" :colon="false"
            labelClassName="transfer-review-label" contentClassName="transfer-review-content">
            <el-descriptions-item :label="$t('message.transfer.youSend')">
              <span style="color:#0094C6">{{ info && info.sendAmount }} {{ info && info.sendCurrency.value }}</span>
            </el-descriptions-item>
            <el-descriptions-item :label="$t('message.transfer.payoutFee')">{{ info && info.serviceFee }} {{ info &&
              info.sendCurrency.value }}</el-descriptions-item>
            <el-descriptions-item v-if="showRate" :label="$t('message.transfer.rate')">
              <template v-if="info && info.rate && (rateCountdown > 0)">
                <span>{{ info && info.rate }}</span>
                <span class="margin-left-30"
                  v-html="$t('message.transfer.validWithin', { time: `${rateCountdown}s` })"></span>
              </template>
            </el-descriptions-item>
            <el-descriptions-item :label="$t('message.transfer.recipientGets')">{{ info && info.getAmount }} {{ info &&
              info.getCurrency.value }}</el-descriptions-item>
            <el-descriptions-item :label="$t('message.transfer.transactionPurpose')">{{ info &&
              info.transactionPurposeText }}</el-descriptions-item>
            <el-descriptions-item v-if="info && info.reference" :label="$t('message.transfer.payoutPostscri')">{{ info
              &&
              info.reference }}</el-descriptions-item>
            <el-descriptions-item v-if="info && info.payerInfo && (info.payerInfo.holderName)"
              :label="$t('message.transfer.payer')">
              {{ info && info.payerInfo && (info.payerInfo.holderName) }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <el-form ref="verifyCodeRef" class="verify-code-form" :model="form" :rules="rules">
          <el-form-item
            :label="paySafeConfigMode === 1 ? `${$t('message.transfer.email')} / ${app && app.userLogin.operatorEmail}` : `${$t('message.validator.input', { input: $t('message.user.payPassword') })}`"
            prop="verficyCode">
            <div class="verify-code">
              <el-input v-model="form.verficyCode" maxlength="6"
                :type="paySafeConfigMode === 2 ? 'password' : 'text'"></el-input>
              <div v-if="paySafeConfigMode === 1" class="btn margin-left-13">
                <el-button v-if="timerCountDown > 0" type="primary">{{ $t('message.user.restTime', {
                  time:
                    timerCountDown
                }) }}</el-button>
                <el-button v-else type="primary" @click="sendCode" :loading="verfifyCodeLoading">{{
                  $t('message.transfer.verfiyCode') }}</el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="margin-top-30 bottom-box-center" style="padding-bottom: 50px;">
          <el-button style="width:100%;" type="primary" @click="submit">{{
            $t('message.common.submit')
          }}</el-button>
          <p class="btn-previous margin-top-10" @click="handlePrevious">{{ $t('message.common.previous') }}</p>
        </div>
      </div>
    </div>
  </rhcn-drawer>
</template>
<script>
import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';

import RhcnDrawer from '@/components/drawer/index.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips';
import RhcnStep from '@/components/step/index.vue';
import { validateFns, REQUIRED } from '@/components/validation/tool/validator';
import { getEnantiomericValue } from '@/utils/tools/constant';
import { formatAmountByCurrency } from '@/utils/tools/currency';
import { getPaySafeConfig } from '@/views/account/security/api/security';
import { getPayeeInfo, queryWalletTypeByCountry } from '@/views/transfer/api/contact';
import {
  PAYMENT_METHOD_OPTIONS, ACCOUNT_BELONG_OPTIONS,
  ENTITY_TYPE_OPTIONS, ACCOUNT_TYPE_OPTIONS,
  COUNTRY_PHONE_CODE_MAP,
} from '@/views/transfer/api/options';
import TransferService from '@/views/transfer/api/transfer';

export default {
  components: { RhcnDrawer, RhcnStep },
  data() {
    return {
      loading: false,
      PAYMENT_METHOD_OPTIONS,
      ACCOUNT_BELONG_OPTIONS,
      ENTITY_TYPE_OPTIONS,
      ACCOUNT_TYPE_OPTIONS,
      COUNTRY_PHONE_CODE_MAP,
      steps: [
        {
          title: 'message.transfer.recipient',
          handler: () => {
            this.$router.push({
              path: '/transfer/transfer/add/recipient',
              query: { businessType: this.businessType },
            });
          },
        },
        {
          title: 'message.exchange.amount',
          handler: () => {
            this.$router.push({
              path: '/transfer/transfer/add/amount',
              query: { id: this.$route.query.id, businessType: this.businessType },
            });
          },
        },
        {
          title: 'message.exchange.review',
        },
      ],
      info: null,
      contactInfo: null,
      verfifyCodeLoading: false,
      form: {
        verficyCode: '',
      },
      rules: {
        verficyCode: [
          { validator: validateFns([REQUIRED]) },
        ],
      },
      timerCountDown: 0,
      paySafeConfigMode: 1, // 2：支付密码验证  1：邮箱验证
      showRate: false, // 是否显示汇率
      rateCountdown: 0,
      walletTypeList: [],
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
    businessType() {
      return this.$route.query.businessType || '';
    },
  },
  created() {
    this.initMethod();
  },
  destroyed() {
    this.timer && clearInterval(this.timer);
    this.rateTimer && clearInterval(this.rateTimer);
  },
  methods: {
    async initMethod() {
      try {
        this.info = JSON.parse(window.sessionStorage.getItem('transferData'));
        if (this.$route.query.id !== this.info.cardInfoId) {
          this.info = null;
          return;
        }
        this.loading = true;
        this.contactInfo = this.info.contactInfo;
        if (!this.contactInfo) {
          await getPayeeInfo({ cardInfoId: this.info.cardInfoId }).then(async (res) => {
            this.contactInfo = res;
          }).catch(() => {
            //
          });
        }
        const resMode = await getPaySafeConfig();
        this.paySafeConfigMode = +resMode.mode === 2 ? 2 : 1; // 2：支付密码验证  1：邮箱验证
        if (this.info && this.info.showRate) {
          this.showRate = this.info.showRate;
          this.rateCountdown = Math.floor((this.info.rateExpireTime - Date.now()) / 1000);
          if (this.rateCountdown > 0) {
            this.onCountdown(this.rateCountdown);
          } else {
            this.refreshRate();
          }
        }
        this.walletTypeList = [];
        if (this.contactInfo.payeeCountry) {
          const res1 = await queryWalletTypeByCountry({ country: this.contactInfo.payeeCountry });
          this.walletTypeList = res1.map(item => ({
            ...item,
            label: item.viewName || item.walletType,
            value: item.walletType,
          }));
        }
      } catch (error) {
        console.log('error transfer info', error);
      }
      this.loading = false;
    },
    sendCode() {
      if (this.timerCountDown > 0) { // 倒计时中
        return;
      }
      this.verfifyCodeLoading = true;
      TransferService.sendTransferVerifyCode().then((res) => {
        this.verfifyCodeLoading = false;
        this.info.requestId = res;
        window.sessionStorage.setItem('transferData', JSON.stringify(this.info));
        ShowSuccessMessage(this.$t('message.transfer.verfiyCodeTip'));
        this.timerCountDown = 59;
        this.timer = setInterval(() => {
          this.timerCountDown -= 1;
          if (this.timerCountDown <= 0) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }).catch((err) => {
        console.log(err);
        this.verfifyCodeLoading = false;
      });
    },
    submit() {
      this.$refs.verifyCodeRef.validate((valid) => {
        if (valid) {
          const loading = Loading.service();
          const submitData = {
            requestId: this.info.requestId,
            payeeId: this.info.cardInfoId,
            payerId: this.info.payerId,
            applyId: (this.info.merchantType === 'B2B' && this.info.isSamePayee === 'Y') ? this.info.payer : '', // 只有B2B商户有这个字段
            sourceAmount: {
              amount: this.info.sendAmount,
              currency: this.info.sendCurrency.value,
            },
            targetAmount: {
              amount: this.info.getAmount,
              currency: this.info.getCurrency.value,
            },
            serviceFeeAmount: {
              amount: this.info.serviceFee,
              currency: this.info.sendCurrency.value,
            },
            transactionPurpose: this.info.transactionPurpose,
            reference: this.info.reference,
            fileId: this.info.fileId ? this.info.fileId[0].uploadFileId : '',
            materialList: this.info.materialList,
            isSamePayee: this.info.isSamePayee,
            isSavePayee: this.info.isSavePayee ? 'Y' : 'N',
            reverseFlag: this.info.exchangeDirection === 1 ? 'Y' : 'N', // 换汇方向 0: 正向  1: 逆向
            payoutMethod: this.info.payoutMethod,
          };
          if (this.paySafeConfigMode === 2) { // 支付密码
            submitData.payPassword = this.form.verficyCode;
          } else {
            submitData.verifyCode = this.form.verficyCode;
          }

          // submitData.payeeAddDTO = this.info.contactInfo;
          submitData.payeeInfo = this.info.contactInfo;

          let hasAreaCode = true;
          for (let i = 0; i < this.walletTypeList.length; i++) {
            if (this.walletTypeList[i].value === this.contactInfo.walletType) {
              if (this.walletTypeList[i].textType === 'TEXT') {
                hasAreaCode = false;
              }
              break;
            }
          }

          if (!hasAreaCode) {
            submitData.payeeInfo.areaCode = null;
          }
          // console.log(submitData, 'submitData');
          // console.log(this.info, 'this.info');
          TransferService.autoPayout(submitData).then((res) => {
            ShowSuccessMessage(this.$t('message.submitSuccessfulTip'));
            window.sessionStorage.removeItem('transferData');
            console.log('errTransferService');
            if (this.businessType) {
              this.$router.push({
                path: `/transfer/transfer/aggregate/${this.businessType}`,
              });
            } else {
              this.$router.push({
                path: '/transfer/transfer',
              });
            }
            loading.close();
          }).catch((err) => {
            // if (['50001', 'cl0001', '50000'].includes(err.respCode)) {
            //   window.sessionStorage.removeItem('transferData');
            //   setTimeout(() => {
            //     if (this.businessType) {
            //       this.$router.push({
            //         path: `/transfer/transfer/aggregate/${this.businessType}`,
            //       });
            //     } else {
            //       this.$router.push({
            //         path: '/transfer/transfer',
            //       });
            //     }
            //     loading.close();
            //   }, 2000);
            // } else {
            //   loading.close();
            // }
            // 00004|00021|cl1009
            // 判断是否包含00004|00021|cl1009 这是一个整体00004|10028
            if (err.respCode.includes('00004|00021|cl1009') || err.respCode.includes('00004|10028')) {
              loading.close();
            } else {
              window.sessionStorage.removeItem('transferData');
              setTimeout(() => {
                if (this.businessType) {
                  this.$router.push({
                    path: `/transfer/transfer/aggregate/${this.businessType}`,
                  });
                } else {
                  this.$router.push({
                    path: '/transfer/transfer',
                  });
                }
                loading.close();
              }, 2000);
            }
          });
        }
      });
    },
    onClose() {
      window.sessionStorage.removeItem('transferData');
      if (this.businessType) {
        this.$router.push({
          path: `/transfer/transfer/aggregate/${this.businessType}`,
        });
      } else {
        this.$router.push({
          path: '/transfer/transfer',
        });
      }
    },
    downloadFile(url) {
      window.location.href = url;
    },
    getEnantiomericValue,
    handlePrevious() {
      this.$router.go(-1);
    },
    async refreshRate() {
      if (!this.showRate) {
        return;
      }
      const SUB_PRODUCT_MAP = {
        0: 'WITHDRAW',
        1: 'PAYMENT',
        2: 'VAT_PAYMENT',
      };
      const isReverse = this.info.exchangeDirection === 1;
      const params = {
        subProduct: SUB_PRODUCT_MAP[(+this.contactInfo.accountBelong)], // 收款人所属0,1,2
        paymentMethod: getEnantiomericValue(PAYMENT_METHOD_OPTIONS, this.contactInfo.paymentMethod), // 支付方式 0, 1
        cardBinCountry: this.contactInfo.bankCountry,
        reverseFlag: isReverse ? 'Y' : 'N',
        sourceAmount: {
          amount: this.info.sendAmount,
          currency: this.info.sendCurrency.value,
        },
        targetAmount: {
          amount: this.info.getAmount,
          currency: this.info.getCurrency.value,
        },
        receiveMethod: this.info.payoutMethod,
      };

      const res = await TransferService.getTransferResult(params);
      this.info.serviceFee = Math.abs(+res.serviceCharge);
      this.info.rate = res.exchangedRate;
      this.info.exchangeAmount = res.exchangedAmount;
      if (isReverse) {
        this.info.sendAmount = formatAmountByCurrency(res.targetAmount, this.info.sendCurrency.value);
      } else {
        this.info.getAmount = formatAmountByCurrency(res.targetAmount, this.info.getCurrency.value);
      }
      this.onCountdown(59);
    },
    onCountdown(count) {
      this.rateCountdown = count;
      this.rateTimer = setInterval(() => {
        this.rateCountdown -= 1;
        if (this.rateCountdown <= 0) {
          clearInterval(this.rateTimer);
          this.rateTimer = null;
          this.refreshRate();
        }
      }, 1000);
    },
    getVatNumberText(contact) {
      let vatName = 'CPF';
      if (contact && `${contact.entityType}` === '0') {
        vatName = 'CNPJ';
      }
      return vatName;
    },
    getWalletTypeText(value) {
      return getEnantiomericValue(this.walletTypeList, value);
    },
    getWalletPhoneText() {
      for (let i = 0; i < this.walletTypeList.length; i++) {
        if (this.walletTypeList[i].value === this.contactInfo.walletType) {
          if (this.walletTypeList[i].textType === 'TEXT') {
            return this.contactInfo.walletPhone;
          } else {
            const areaCode = COUNTRY_PHONE_CODE_MAP[this.contactInfo.bankCountry];
            return areaCode ? areaCode + ' ' + this.contactInfo.walletPhone : this.contactInfo.walletPhone;
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';

.exchange-form {
  margin-top: -68px;
}

.transfer-review-wrapper {
  margin-top: 60px;

  .content {
    padding: 20px 30px;
    background: $color-default;
    border-radius: 4px;

    .el-descriptions__header {
      .el-descriptions__title {
        font-size: 14px;
        font-weight: bold;
        line-height: 19px
      }
    }

    .el-descriptions__body {
      background: none;
    }

    .transfer-review-label {
      font-size: 14px;
      font-weight: normal;
      line-height: 19px;
      width: 167px;
    }

    .transfer-review-content {
      font-size: 14px;
      font-weight: bold;
      line-height: 19px;
    }
  }

  .verify-code-form {
    margin-top: 20px;

    .el-form-item__label {
      line-height: 20px;
      margin-bottom: 5px;
      font-weight: 600;
    }

    .verify-code {
      display: flex;
      width: 100%;

      .el-button {
        min-width: 180px;
        background-color: $color-text-primary;
        border-color: $color-text-primary;
      }
    }
  }

  .bottom-box-center {
    display: flex;
    flex-direction: column;
    align-items: center;

    .btn-previous {
      cursor: pointer;
      color: $color-text-default-button;
      font-weight: 600;
    }
  }
}
</style>
